/**
 * RISE SKIN CONCIERGE
 * Product Intelligence Layer
 *
 * Source of truth:
 * Rise AI Skin Concierge Brain v1.1
 *
 * IMPORTANT:
 * This file describes products.
 * It does NOT decide which product wins.
 *
 * Recommendation logic belongs in:
 * rise-skin-engine.js
 */

window.RISE_DEBUG = true;

window.RISE_SKIN_PRODUCTS = [

  // ============================================================
  // SKINBETTER SCIENCE
  // ============================================================

  {
    id: "skinbetter-alpharet-overnight-cream",
    brand: "SkinBetter Science",
    name: "AlphaRet Overnight Cream",
    category: "retinoid",
    routineSlot: "corrective",
    amPm: ["PM"],

    concerns: {
      acne: 2,
      pores: 5,
      texture: 5,
      pigment: 3,
      redness: 0,
      fineLines: 5,
      laxity: 2,
      dullness: 4,
      dehydration: 0,
      congestion: 2,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 3,
      sensitive: 2,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["retinoid", "aha"],
    activeLoad: 3,

    gates: {
      pregnancy: "block",
      breastfeeding: "review",
      prescriptionRetinoid: "block",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: [
      "retinoid",
      "strong-exfoliation"
    ],

    reasonTags: [
      "PORES",
      "TEXTURE",
      "FINE_LINES",
      "AGING",
      "DULLNESS",
      "RETINOID"
    ],

    specialtyModules: [],

        usage: {
      timing: "PM",
      directions: "Apply a thin layer to clean, dry face, avoiding the eye area. Follow with moisturizer as needed; use SPF daily."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-intensive-alpharet-overnight-cream",
    brand: "SkinBetter Science",
    name: "Intensive AlphaRet Overnight Cream",
    category: "retinoid",
    routineSlot: "corrective",
    amPm: ["PM"],

    concerns: {
      acne: 2,
      pores: 5,
      texture: 5,
      pigment: 3,
      redness: 0,
      fineLines: 5,
      laxity: 3,
      dullness: 4,
      dehydration: 0,
      congestion: 2,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 3,
      sensitive: 1,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["retinoid", "aha"],
    activeLoad: 4,

    gates: {
      pregnancy: "block",
      breastfeeding: "review",
      prescriptionRetinoid: "block",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      retinoidNaive: "deprioritize"
    },

    conflicts: [
      "retinoid",
      "strong-exfoliation"
    ],

    reasonTags: [
      "PORES",
      "TEXTURE",
      "FINE_LINES",
      "ADVANCED_AGING",
      "RETINOID"
    ],

    specialtyModules: [],

        usage: {
      timing: "PM",
      directions: "Apply a thin layer to clean, dry face, avoiding the eye area. Follow with moisturizer as needed; use SPF daily."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-eyemax-alpharet",
    brand: "SkinBetter Science",
    name: "EyeMax AlphaRet Overnight Cream",
    category: "eye-retinoid",
    routineSlot: "eye",
    amPm: ["PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 1,
      redness: 0,
      fineLines: 5,
      laxity: 2,
      dullness: 1,
      dehydration: 1,
      congestion: 0,
      underEye: 5
    },

    fit: {
      oily: 4,
      combination: 4,
      balanced: 5,
      dry: 4,
      sensitive: 2,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["retinoid"],
    activeLoad: 2,

    gates: {
      pregnancy: "block",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: ["eye-retinoid"],

    reasonTags: [
      "UNDER_EYE",
      "EYE_FINE_LINES",
      "EYE_TEXTURE",
      "RETINOID"
    ],

    specialtyModules: ["eye"],

        usage: {
      timing: "PM",
      directions: "Apply a rice-grain amount to clean, dry skin around the under-eye area. Gently dab outward and avoid the eyelids."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-alpharet-clearing-serum",
    brand: "SkinBetter Science",
    name: "AlphaRet Clearing Serum",
    category: "acne-retinoid",
    routineSlot: "corrective",
    amPm: ["PM"],

    concerns: {
      acne: 5,
      pores: 5,
      texture: 5,
      pigment: 3,
      redness: 0,
      fineLines: 3,
      laxity: 0,
      dullness: 3,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 2,
      sensitive: 1,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["retinoid", "salicylic-acid"],
    activeLoad: 4,

    gates: {
      pregnancy: "block",
      breastfeeding: "review",
      prescriptionRetinoid: "block",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: [
      "retinoid",
      "benzoyl-peroxide",
      "strong-exfoliation"
    ],

    reasonTags: [
      "ACNE",
      "CONGESTION",
      "PORES",
      "TEXTURE",
      "RETINOID"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "PM",
      directions: "Apply a thin layer to clean, dry face, avoiding the eye area. Follow with moisturizer as needed; use SPF daily."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-alto-advanced-defense-repair-serum",
    brand: "SkinBetter Science",
    name: "Alto Advanced Defense and Repair Serum",
    category: "antioxidant",
    routineSlot: "antioxidant",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 1,
      texture: 2,
      pigment: 4,
      redness: 4,
      fineLines: 4,
      laxity: 2,
      dullness: 4,
      dehydration: 1,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["antioxidant"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "ANTIOXIDANT",
      "REDNESS",
      "PIGMENT",
      "DULLNESS",
      "FINE_LINES",
      "UV_EXPOSURE"
    ],

    specialtyModules: [],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete before moisturizer."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-even-tone-correcting-serum",
    brand: "SkinBetter Science",
    name: "Even Tone Correcting Serum",
    category: "pigment-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 1,
      texture: 2,
      pigment: 5,
      redness: 2,
      fineLines: 1,
      laxity: 0,
      dullness: 4,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 3,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["brightening"],
    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "PIGMENT",
      "UNEVEN_TONE",
      "POST_ACNE_MARKS",
      "DULLNESS"
    ],

    specialtyModules: ["pigment"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete. Follow with moisturizer and SPF in the morning."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-mystro-active-balance-serum",
    brand: "SkinBetter Science",
    name: "Mystro Active Balance Serum",
    category: "redness-barrier",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 2,
      texture: 2,
      pigment: 2,
      redness: 5,
      fineLines: 2,
      laxity: 1,
      dullness: 3,
      dehydration: 2,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["barrier-support", "redness-support"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "REDNESS",
      "SENSITIVITY",
      "BARRIER",
      "SKIN_BALANCE"
    ],

    specialtyModules: ["redness"],

        usage: {
      timing: "AM + PM",
      directions: "Dispense 1 pump, dot over forehead, cheeks, and chin, then massage until absorbed. Allow to dry completely before layering."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    {
    id: "skinbetter-interfuse-treatment-cream-face-neck",
    brand: "SkinBetter Science",
    name: "InterFuse Treatment Cream FACE & NECK",
    category: "peptide-moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 1,
      texture: 3,
      pigment: 0,
      redness: 1,
      fineLines: 5,
      laxity: 4,
      dullness: 2,
      dehydration: 4,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 3,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["peptide", "moisturizer"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "FINE_LINES",
      "FIRMNESS",
      "DEHYDRATION",
      "AGING"
    ],

    specialtyModules: ["aging"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-interfuse-treatment-cream-eye",
    brand: "SkinBetter Science",
    name: "InterFuse Treatment Cream EYE",
    category: "eye-treatment",
    routineSlot: "eye",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 1,
      redness: 0,
      fineLines: 5,
      laxity: 3,
      dullness: 1,
      dehydration: 4,
      congestion: 0,
      underEye: 5
    },

    fit: {
      oily: 4,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["peptide", "eye-treatment"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "UNDER_EYE",
      "EYE_FINE_LINES",
      "EYE_DEHYDRATION",
      "EYE_FIRMNESS"
    ],

    specialtyModules: ["eye"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a rice-grain amount to clean, dry skin around the under-eye area."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-trio-rebalancing-moisture-treatment",
    brand: "SkinBetter Science",
    name: "Trio Rebalancing Moisture Treatment",
    category: "moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 0,
      redness: 2,
      fineLines: 2,
      laxity: 1,
      dullness: 2,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 3,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["moisturizer", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "DEHYDRATION",
      "DRYNESS",
      "BARRIER",
      "SENSITIVITY"
    ],

    specialtyModules: ["barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete as your moisturizing step."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-trio-luxe-moisture-treatment",
    brand: "SkinBetter Science",
    name: "Trio Luxe Moisture Treatment",
    category: "rich-moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 0,
      redness: 2,
      fineLines: 3,
      laxity: 1,
      dullness: 2,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 1,
      combination: 3,
      balanced: 4,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 2
    },

    activeClasses: ["moisturizer", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "VERY_DRY",
      "DEHYDRATION",
      "BARRIER",
      "MATURE_SKIN"
    ],

    specialtyModules: ["barrier", "aging"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps to face, neck, and decollete as your moisturizing step."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-hydration-boosting-cream",
    brand: "SkinBetter Science",
    name: "Hydration Boosting Cream",
    category: "moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 1,
      pigment: 0,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 1,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 3,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["moisturizer"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "HYDRATION",
      "DRYNESS",
      "BARRIER"
    ],

    specialtyModules: ["barrier"],

        usage: {
      timing: "AM + PM / AS NEEDED",
      directions: "Apply as needed as your moisturizing step. In the morning, follow with SPF."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-cleansing-gel",
    brand: "SkinBetter Science",
    name: "Cleansing Gel",
    category: "cleanser",
    routineSlot: "cleanser",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 1,
      texture: 1,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 1,
      dehydration: 0,
      congestion: 1,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 4,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["cleanser"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: ["CLEANSER"],

    specialtyModules: [],

        usage: {
      timing: "AM + PM",
      directions: "Apply a generous amount to damp skin, massage gently with fingertips, and rinse with warm water."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "refining-foam-cleanser",
    brand: "SkinBetter Science",
    name: "Refining Foam Cleanser",
    category: "active-cleanser",
    routineSlot: "cleanser",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 3,
      pores: 4,
      texture: 3,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 3,
      dehydration: 0,
      congestion: 4,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 2,
      sensitive: 2,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["active-cleanser"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: [],

    reasonTags: [
      "PORES",
      "CONGESTION",
      "OILINESS",
      "DULLNESS"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps to damp skin, massage gently, and rinse with warm water. Avoid direct eye contact."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    {
    id: "skinbetter-techno-neck-perfecting-cream",
    brand: "SkinBetter Science",
    name: "Techno Neck Perfecting Cream",
    category: "neck-treatment",
    routineSlot: "specialty",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 1,
      redness: 0,
      fineLines: 4,
      laxity: 5,
      dullness: 1,
      dehydration: 3,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["peptide", "neck-treatment"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "NECK",
      "FIRMNESS",
      "LAXITY",
      "NECK_LINES"
    ],

    specialtyModules: ["neck"],

        usage: {
      timing: "AM + PM",
      directions: "Apply to the neck and decollete using upward motions. In the morning, follow with SPF."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-instant-effect-gel-eye",
    brand: "SkinBetter Science",
    name: "Instant Effect Gel EYE",
    category: "eye-treatment",
    routineSlot: "eye",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 1,
      pigment: 1,
      redness: 0,
      fineLines: 3,
      laxity: 2,
      dullness: 1,
      dehydration: 2,
      congestion: 0,
      underEye: 4
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["eye-treatment"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "UNDER_EYE",
      "PUFFINESS",
      "EYE_FINE_LINES"
    ],

    specialtyModules: ["eye"],

        usage: {
      timing: "AM + PM / AS NEEDED",
      directions: "Dispense up to 1 pump and use the rollerball in small circular motions around the eye area."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-interfuse-lines",
    brand: "SkinBetter Science",
    name: "InterFuse Intensive Treatment LINES",
    category: "line-treatment",
    routineSlot: "specialty",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 0,
      redness: 0,
      fineLines: 5,
      laxity: 2,
      dullness: 1,
      dehydration: 2,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["peptide", "line-treatment"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "FINE_LINES",
      "ETCHED_LINES",
      "AGING"
    ],

    specialtyModules: ["aging"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer directly to lines and wrinkles on clean, dry skin before other treatment products."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-solo-hydrating-defense-men",
    brand: "SkinBetter Science",
    name: "Solo Hydrating Defense MEN",
    category: "moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 1,
      texture: 2,
      pigment: 0,
      redness: 2,
      fineLines: 2,
      laxity: 1,
      dullness: 2,
      dehydration: 4,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 4,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["moisturizer", "antioxidant"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review"
    },

    conflicts: [],

    reasonTags: [
      "HYDRATION",
      "REDNESS",
      "MEN",
      "SIMPLE_ROUTINE"
    ],

    specialtyModules: [],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face and neck. In the morning, follow with SPF."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  // ============================================================
  // SKINBETTER — REMAINING PRODUCTS
  // ============================================================

  {
    id: "skinbetter-detoxifying-scrub-mask",
    brand: "SkinBetter Science",
    name: "Detoxifying Scrub Mask",
    category: "exfoliation",
    routineSlot: "specialty",
    amPm: ["INTERMITTENT"],

    concerns: {
      acne: 0,
      pores: 5,
      texture: 5,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 3,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 2,
      sensitive: 1,
      resilient: 5,
      acneProne: 2
    },

    activeClasses: ["exfoliation"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: ["strong-exfoliation"],

    reasonTags: [
      "TEXTURE",
      "PORES",
      "OILINESS",
      "OPTIONAL_EXFOLIATION"
    ],

    specialtyModules: ["exfoliation"],

        usage: {
      timing: "1-3X WEEKLY",
      directions: "Apply to damp skin, gently massage, then allow to sit briefly before rinsing thoroughly. Avoid over-exfoliating with other active products."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-alto-defense-serum",
    brand: "SkinBetter Science",
    name: "Alto Defense Serum",
    category: "antioxidant",
    routineSlot: "antioxidant",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 3,
      redness: 3,
      fineLines: 0,
      laxity: 0,
      dullness: 5,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["antioxidant"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-antioxidant"],

    reasonTags: [
      "ANTIOXIDANT",
      "UV_EXPOSURE",
      "DULLNESS",
      "PIGMENT",
      "REDNESS"
    ],

    specialtyModules: [],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete before moisturizer."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-even-intensive",
    brand: "SkinBetter Science",
    name: "Even Intensive Skin Tone Correcting Serum",
    category: "advanced-pigment-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 3,
      texture: 3,
      pigment: 5,
      redness: 3,
      fineLines: 0,
      laxity: 0,
      dullness: 3,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 3,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["brightening", "exfoliation"],
    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer"
    },

    conflicts: [
      "strong-exfoliation",
      "duplicate-pigment-corrective"
    ],

    reasonTags: [
      "PIGMENT",
      "STUBBORN_PIGMENT",
      "UNEVEN_TONE",
      "DULLNESS"
    ],

    specialtyModules: ["pigment"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a thin layer to clean, dry face, neck, and decollete. Follow with moisturizer and SPF in the morning."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-mystro-revive",
    brand: "SkinBetter Science",
    name: "Mystro Revive Renewing Serum",
    category: "age-support-serum",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 5,
      laxity: 5,
      dullness: 5,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 2,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 2
    },

    activeClasses: [
      "age-support",
      "hydration"
    ],

    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-anti-aging-serum"],

    reasonTags: [
      "MATURE_SKIN",
      "DULLNESS",
      "ELASTICITY",
      "HYDRATION",
      "FINE_LINES"
    ],

    specialtyModules: ["aging"],

        usage: {
      timing: "AM + PM",
      directions: "Apply to clean, dry face and neck before moisturizer. Allow to absorb before layering additional products."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-alpharet-exfoliating-peel-pads",
    brand: "SkinBetter Science",
    name: "AlphaRet Exfoliating Peel Pads",
    category: "advanced-exfoliation",
    routineSlot: "specialty",
    amPm: ["PM", "INTERMITTENT"],

    concerns: {
      acne: 0,
      pores: 5,
      texture: 5,
      pigment: 3,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 5,
      dehydration: 0,
      congestion: 3,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 2,
      sensitive: 1,
      resilient: 5,
      acneProne: 2
    },

    activeClasses: [
      "retinoid",
      "exfoliation"
    ],

    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      retinoidNaive: "deprioritize",
      providerReview: true
    },

    conflicts: [
      "retinoid",
      "strong-exfoliation"
    ],

    reasonTags: [
      "TEXTURE",
      "DULLNESS",
      "PORES",
      "ADVANCED_EXFOLIATION"
    ],

    specialtyModules: ["exfoliation"],

        usage: {
      timing: "PM \u00b7 UP TO 3X WEEKLY",
      directions: "Swipe one pad over clean, dry face, avoiding the eye area. Do not rinse; allow to dry before the rest of your routine. Use SPF daily."
    },

commerce: {
      route: "skinbetter",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
{
  id: "skinbetter-alpharet-body-overnight-cream",
  brand: "SkinBetter Science",
  name: "AlphaRet Body Overnight Cream",
  category: "body-corrective",
  routineSlot: "body",
  amPm: ["PM"],

  concerns: {
    acne: 0,
    pores: 0,
    texture: 0,
    pigment: 0,
    redness: 0,
    fineLines: 0,
    laxity: 0,
    dullness: 0,
    dehydration: 0,
    congestion: 0,
    underEye: 0
  },

  fit: {
    oily: 0,
    combination: 0,
    balanced: 0,
    dry: 0,
    sensitive: 0,
    resilient: 0,
    acneProne: 0
  },

  activeClasses: [
    "body-treatment",
    "retinoid",
    "exfoliation"
  ],

  activeLoad: 2,

  gates: {
    pregnancy: "block",
    breastfeeding: "review",
    prescriptionRetinoid: "review",
    barrierImpaired: "defer",
    severeSensitivity: "review",
    facialRoutine: "block"
  },

  conflicts: [
    "body-retinoid",
    "strong-exfoliation"
  ],

  reasonTags: [
    "BODY",
    "BODY_TEXTURE",
    "BODY_PIGMENT",
    "BODY_BREAKOUTS",
    "BODY_SKIN_QUALITY"
  ],

  specialtyModules: ["body"],

    usage: {
    timing: "PM",
    directions: "Apply a thin layer nightly to desired areas on the body. Not intended for facial use; use SPF on exposed areas."
  },

commerce: {
    route: "skinbetter",
    productHandle: null,
    productId: null,
    variantId: null
  }
},
  // ============================================================
  // SKINBETTER SPF
  // ============================================================

  {
    id: "skinbetter-sunbetter-sheer-spf-56-stick",
    brand: "SkinBetter Science",
    name: "Sunbetter Sheer SPF 56 Sunscreen Stick",
    category: "spf-reapplication",
    routineSlot: "spf",
    amPm: ["AM", "REAPPLY"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 1,
      redness: 1,
      fineLines: 2,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "REAPPLICATION",
      "OUTDOOR",
      "PORTABILITY"
    ],

    specialtyModules: ["spf-reapplication"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Apply generously as the last step of your morning routine before sun exposure. Reapply at least every 2 hours and after swimming or sweating."
    },

commerce: {
      route: "skinbetter",
      productHandle: "sunbetter-sheer-sunscreen-stick-spf-56",
      productId: null,
      variantId: null
    }
  },
    {
    id: "skinbetter-sunbetter-tone-smart-spf-68-compact",
    brand: "SkinBetter Science",
    name: "Sunbetter Tone Smart SPF 68 Sunscreen Compact",
    category: "tinted-spf",
    routineSlot: "spf",
    amPm: ["AM", "REAPPLY"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 1,
      fineLines: 2,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "TINTED",
      "COVERAGE",
      "PORTABILITY",
      "REAPPLICATION"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Apply generously and evenly as the last step of your morning routine. Reapply at least every 2 hours and after swimming or sweating."
    },

commerce: {
      route: "skinbetter",
      productHandle: "sunbetter-tone-smart-sunscreen-compact-spf-68",
      productId: null,
      variantId: null
    }
  },

  {
    id: "skinbetter-sunbetter-tone-smart-spf-75-lotion",
    brand: "SkinBetter Science",
    name: "Sunbetter Tone Smart SPF 75 Sunscreen Lotion",
    category: "tinted-spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 1,
      fineLines: 2,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "TINTED",
      "COVERAGE",
      "DAILY_PROTECTION"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Warm product between fingertips, then apply generously over face, neck, and decollete 15 minutes before sun exposure. Reapply at least every 2 hours."
    },

commerce: {
      route: "skinbetter",
      productHandle: "sunbetter-tone-smart-sunscreen-spf-75",
      productId: null,
      variantId: null
    }
  },

  // ============================================================
  // PLATED
  // ============================================================

  {
    id: "plated-intense",
    brand: "Plated",
    name: "INTENSE Serum",
    category: "regenerative-serum",
    routineSlot: "regenerative",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 2,
      texture: 4,
      pigment: 3,
      redness: 3,
      fineLines: 5,
      laxity: 4,
      dullness: 5,
      dehydration: 2,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["regenerative", "exosome-derived-signaling"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-regenerative"],

    reasonTags: [
      "REGENERATIVE",
      "FINE_LINES",
      "TEXTURE",
      "DULLNESS",
      "REDNESS",
      "AGING",
      "PREMIUM"
    ],

    specialtyModules: ["aging"],

        usage: {
      timing: "AM +/OR PM",
      directions: "Apply 1 pump to clean, dry skin before other skincare. Wait about 5 minutes before layering additional products."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "plated-eye",
    brand: "Plated",
    name: "EYE Serum",
    category: "eye-regenerative",
    routineSlot: "eye",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 2,
      redness: 0,
      fineLines: 5,
      laxity: 4,
      dullness: 2,
      dehydration: 2,
      congestion: 0,
      underEye: 5
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["regenerative", "eye-treatment"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-eye-treatment"],

    reasonTags: [
      "UNDER_EYE",
      "EYE_FINE_LINES",
      "PUFFINESS",
      "DARK_CIRCLES",
      "EYE_FIRMNESS",
      "PREVENTION"
    ],

    specialtyModules: ["eye"],

        usage: {
      timing: "AM + PM",
      directions: "Use about 1/2 pump per eye on clean, dry skin around the eye area. Allow to absorb before layering other products."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  // ============================================================
  // HYDRINITY — QUIZ-APPROVED ONLY
  // ============================================================

  {
    id: "hydrinity-hyacyn-active",
    brand: "Hydrinity",
    name: "HYACYN ACTIVE",
    category: "barrier-recovery",
    routineSlot: "support",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 2,
      pores: 0,
      texture: 1,
      pigment: 0,
      redness: 5,
      fineLines: 0,
      laxity: 0,
      dullness: 1,
      dehydration: 2,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hypochlorous-support", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "REDNESS",
      "SENSITIVITY",
      "BARRIER",
      "POST_PROCEDURE",
      "ACNE_SUPPORT"
    ],

    specialtyModules: ["barrier", "recovery"],

        usage: {
      timing: "AM + PM / AS NEEDED",
      directions: "After cleansing, mist 2-4 pumps directly onto face and neck. Allow to dry completely before applying serums."
    },

commerce: {
      route: "shopify",
      productHandle: "hyacyn-active-spray",
      productId: null,
      variantId: null
    }
  },

  {
    id: "hydrinity-restorative-ha-sheet-mask",
    brand: "Hydrinity",
    name: "Restorative HA+ Masque",
    category: "hydration-mask",
    routineSlot: "specialty",
    amPm: ["INTERMITTENT"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 1,
      pigment: 0,
      redness: 3,
      fineLines: 1,
      laxity: 0,
      dullness: 3,
      dehydration: 5,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["hydration", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "HYDRATION",
      "RECOVERY",
      "REDNESS",
      "EVENT_GLOW",
      "BARRIER"
    ],

    specialtyModules: ["mask", "recovery"],

        usage: {
      timing: "1-2X WEEKLY",
      directions: "Apply to clean, dry face for 10-15 minutes. Remove, massage remaining serum into skin, and do not rinse."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    // ============================================================
  // ANFISA
  // ============================================================

  {
    id: "anfisa-an-dew",
    brand: "ANFISA",
    name: "ÂN-DEW 10% Azelaic Acid + PHA Serum",
    category: "corrective-serum",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 3,
      pores: 2,
      texture: 4,
      pigment: 5,
      redness: 5,
      fineLines: 1,
      laxity: 0,
      dullness: 4,
      dehydration: 0,
      congestion: 2,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 3,
      sensitive: 3,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["azelaic-acid", "pha", "exfoliation"],
    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "review"
    },

    conflicts: ["strong-exfoliation"],

    reasonTags: [
      "REDNESS",
      "PIGMENT",
      "TEXTURE",
      "ACNE",
      "POST_ACNE_MARKS",
      "DULLNESS"
    ],

    specialtyModules: ["redness", "pigment"],

        usage: {
      timing: "AM + PM",
      directions: "Apply to clean skin before moisturizer. Start gradually if sensitive and follow with SPF in the morning."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "anfisa-an-balm",
    brand: "ANFISA",
    name: "ÂN-BALM Radiant Hydra-Balm",
    category: "barrier-balm",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 1,
      pigment: 0,
      redness: 3,
      fineLines: 2,
      laxity: 0,
      dullness: 3,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 2,
      combination: 3,
      balanced: 4,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 2
    },

    activeClasses: ["barrier-support", "emollient"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-rich-moisturizer"],

    reasonTags: [
      "DRYNESS",
      "DEHYDRATION",
      "BARRIER",
      "SENSITIVITY",
      "RICH_MOISTURE"
    ],

    specialtyModules: ["barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply about a pea-sized amount to damp skin and gently press and massage over face, neck, and decollete."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "anfisa-an-gloss",
    brand: "ANFISA",
    name: "ÂN-GLOSS Ceramide Lip Treatment",
    category: "lip-treatment",
    routineSlot: "specialty",
    amPm: ["AM", "PM", "AS_NEEDED"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 2,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["lip-barrier"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "LIP_CARE",
      "LIP_DRYNESS",
      "OPTIONAL_LUXURY"
    ],

    specialtyModules: ["lip"],

        usage: {
      timing: "AS NEEDED",
      directions: "Apply throughout the day or night for moisture and shine. Use alone as a leave-on lip treatment or over lip color."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  // ============================================================
  // ALASTIN
  // ============================================================

  {
    id: "alastin-hydratint-pro-mineral-spf-36",
    brand: "Alastin",
    name: "HydraTint Pro Mineral Broad Spectrum Sunscreen SPF 36",
    category: "tinted-spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 2,
      fineLines: 2,
      laxity: 0,
      dullness: 1,
      dehydration: 2,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["spf", "hydration"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "TINTED",
      "COVERAGE",
      "HYDRATION",
      "NATURAL_FINISH"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Apply generously 15 minutes before sun exposure, alone or under makeup. Reapply at least every 2 hours and after swimming, sweating, or towel drying."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-ha-immerse-serum",
    brand: "Alastin",
    name: "HA IMMERSE Serum",
    category: "hydrating-serum",
    routineSlot: "hydration",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 2,
      pigment: 0,
      redness: 1,
      fineLines: 2,
      laxity: 1,
      dullness: 2,
      dehydration: 5,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hydration", "hyaluronic-acid"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-hydration-serum"],

    reasonTags: [
      "HYDRATION",
      "DEHYDRATION",
      "PLUMPING",
      "BARRIER_SUPPORT"
    ],

    specialtyModules: [],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps as the first product after cleansing to face and neck. Avoid direct eye contact."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-restorative-skin-complex",
    brand: "Alastin",
    name: "Restorative Skin Complex",
    category: "regenerative-age-support",
    routineSlot: "regenerative",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 1,
      texture: 4,
      pigment: 1,
      redness: 1,
      fineLines: 5,
      laxity: 5,
      dullness: 4,
      dehydration: 3,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["regenerative", "peptide", "age-support"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-regenerative"],

    reasonTags: [
      "FINE_LINES",
      "FIRMNESS",
      "LAXITY",
      "TEXTURE",
      "DULLNESS",
      "AGING"
    ],

    specialtyModules: ["aging"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1 pump to clean skin on the face and neck. Follow with moisturizer and SPF in the morning."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-regenerating-skin-nectar",
    brand: "Alastin",
    name: "Regenerating Skin Nectar",
    category: "procedure-recovery",
    routineSlot: "support",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 3,
      pigment: 0,
      redness: 3,
      fineLines: 3,
      laxity: 3,
      dullness: 2,
      dehydration: 3,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["regenerative", "procedure-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "review",
      severeSensitivity: "review",
      procedureContextRequired: true
    },

    conflicts: ["duplicate-regenerative"],

    reasonTags: [
      "POST_PROCEDURE",
      "RECOVERY",
      "REDNESS",
      "BARRIER",
      "COLLAGEN_SUPPORT"
    ],

    specialtyModules: ["recovery", "procedure"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps to clean skin on treatment areas, or use as directed by your provider around procedures."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-inhance-post-injection-serum",
    brand: "Alastin",
    name: "INhance Post-Injection Serum",
    category: "post-injection",
    routineSlot: "specialty",
    amPm: ["AS_DIRECTED"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 2,
      fineLines: 1,
      laxity: 0,
      dullness: 0,
      dehydration: 1,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["post-injection-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review",
      injectionContextRequired: true
    },

    conflicts: [],

    reasonTags: [
      "POST_INJECTION",
      "SPECIALTY",
      "RECOVERY"
    ],

    specialtyModules: ["injectables", "recovery"],

        usage: {
      timing: "POST-PROCEDURE \u00b7 4X DAILY",
      directions: "After injectable treatment, apply a small amount directly on and around injection areas using the cooling tip. Use 4 times daily until empty."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-transform-body-treatment",
    brand: "Alastin",
    name: "TransFORM Body Treatment",
    category: "body-treatment",
    routineSlot: "body",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 0,
      combination: 0,
      balanced: 0,
      dry: 0,
      sensitive: 0,
      resilient: 0,
      acneProne: 0
    },

    activeClasses: ["body-treatment"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "review",
      facialRoutine: "block"
    },

    conflicts: [],

    reasonTags: [
      "BODY",
      "SPECIALTY_ONLY"
    ],

    specialtyModules: ["body"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 2-3 pumps morning and evening to desired or treated areas on the body."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "alastin-injection-duo-kit",
    brand: "Alastin",
    name: "Injection Duo Kit",
    category: "post-injection-kit",
    routineSlot: "specialty",
    amPm: ["AS_DIRECTED"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 2,
      fineLines: 1,
      laxity: 0,
      dullness: 0,
      dehydration: 1,
      congestion: 0,
      underEye: 1
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["post-injection-support", "bundle"],
    activeLoad: 0,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review",
      injectionContextRequired: true
    },

    conflicts: ["duplicate-post-injection-kit"],

    reasonTags: [
      "POST_INJECTION",
      "SPECIALTY",
      "BUNDLE"
    ],

    specialtyModules: ["injectables", "recovery"],

        usage: {
      timing: "POST-INJECTION",
      directions: "Use the included products as directed after injectable treatment: apply INhance first to injection areas, then use the companion product according to package directions."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    // ============================================================
  // FACE REALITY — CORE / SUPPORT
  // ============================================================

  {
    id: "face-reality-ultra-gentle-gel-cleanser",
    brand: "Face Reality",
    name: "Ultra Gentle Gel Cleanser",
    category: "acne-safe-cleanser",
    routineSlot: "cleanser",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 3,
      combination: 4,
      balanced: 4,
      dry: 3,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["cleanser"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "ACNE_SAFE",
      "GENTLE_CLEANSER",
      "INFLAMMATORY_ACNE",
      "COMEDONAL_ACNE"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a small amount to damp skin and massage into a light lather without aggressive rubbing. Rinse with tepid water and pat dry."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-barrier-balance-creamy-cleanser",
    brand: "Face Reality",
    name: "Barrier Balance Creamy Cleanser",
    category: "acne-safe-cleanser",
    routineSlot: "cleanser",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 1,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 2,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 2,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["cleanser", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "ACNE_SAFE",
      "DRY_SKIN",
      "SENSITIVE_SKIN",
      "BARRIER_SUPPORT"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Massage onto damp skin to cleanse, then rinse thoroughly with tepid water and pat dry."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-hydrabalance-gel",
    brand: "Face Reality",
    name: "HydraBalance Gel",
    category: "hydrating-gel",
    routineSlot: "hydration",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 1,
      fineLines: 0,
      laxity: 0,
      dullness: 1,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hydration"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-hydration-serum"],

    reasonTags: [
      "HYDRATION",
      "DEHYDRATION",
      "ACNE_SAFE",
      "BARRIER_SUPPORT"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps to face and neck. Layer under moisturizer, acne treatment, or sunscreen as directed."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-hydraremedy-gel-serum",
    brand: "Face Reality",
    name: "HydraRemedy Gel Serum",
    category: "barrier-hydration-serum",
    routineSlot: "hydration",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 5,
      fineLines: 0,
      laxity: 0,
      dullness: 1,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hydration", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-hydration-serum"],

    reasonTags: [
      "HYDRATION",
      "REDNESS",
      "SENSITIVITY",
      "BARRIER_SUPPORT",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "barrier", "redness"],

        usage: {
      timing: "AM + PM",
      directions: "Apply 1-2 pumps to face and neck twice daily. Layer under moisturizer or sunscreen."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-clearderma-moisturizer",
    brand: "Face Reality",
    name: "Clearderma Moisturizer",
    category: "acne-safe-moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 4,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 1,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 5,
      congestion: 4,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["moisturizer", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-moisturizer"],

    reasonTags: [
      "ACNE_SAFE",
      "HYDRATION",
      "BARRIER_SUPPORT",
      "INFLAMMATORY_ACNE",
      "COMEDONAL_ACNE"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a dime-sized amount to face and neck. In the morning, follow with SPF."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-cran-peptide-cream",
    brand: "Face Reality",
    name: "Cran-Peptide Cream",
    category: "rich-acne-safe-moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 4,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 0,
      dehydration: 3,
      congestion: 4,
      underEye: 0
    },

    fit: {
      oily: 2,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["moisturizer", "peptide"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-moisturizer"],

    reasonTags: [
      "ACNE_SAFE",
      "DRY_SKIN",
      "RICH_MOISTURE",
      "BARRIER_SUPPORT"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a pea-sized amount to face and neck. In the morning, follow with SPF."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-barrier-care-gel-cream",
    brand: "Face Reality",
    name: "Barrier Care Gel Cream",
    category: "barrier-moisturizer",
    routineSlot: "moisturizer",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 2,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 3,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["moisturizer", "barrier-support"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-moisturizer"],

    reasonTags: [
      "BARRIER",
      "DEHYDRATION",
      "SENSITIVITY",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "Apply a dime-sized amount to face and neck. Layer over a hydrator if extra hydration is needed."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-soothing-radiance-toner",
    brand: "Face Reality",
    name: "Soothing Radiance Toner",
    category: "toner",
    routineSlot: "support",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 1,
      fineLines: 0,
      laxity: 0,
      dullness: 3,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hydration", "toner"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-toner"],

    reasonTags: [
      "HYDRATION",
      "DULLNESS",
      "BARRIER_SUPPORT",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "After cleansing, apply a quarter-sized amount to a cotton round and sweep gently over the face."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-moisture-balance-toner",
    brand: "Face Reality",
    name: "Moisture Balance Toner",
    category: "toner",
    routineSlot: "support",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 1,
      dehydration: 5,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["hydration", "toner"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: ["duplicate-toner"],

    reasonTags: [
      "HYDRATION",
      "DRY_SKIN",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "barrier"],

        usage: {
      timing: "AM + PM",
      directions: "After cleansing, apply a quarter-sized amount to a cotton round and sweep over the face."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-sal-c-toner",
    brand: "Face Reality",
    name: "Sal-C Toner",
    category: "acne-exfoliating-toner",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 4,
      pores: 4,
      texture: 3,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 2,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 3,
      dry: 1,
      sensitive: 2,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["salicylic-acid", "exfoliation"],
    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      providerReview: true
    },

    conflicts: [
      "strong-exfoliation",
      "retinoid",
      "benzoyl-peroxide"
    ],

    reasonTags: [
      "ACNE",
      "CONGESTION",
      "OILINESS",
      "PORES",
      "PROVIDER_GUIDED"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AM +/OR PM",
      directions: "After cleansing, apply a quarter-sized amount to a cotton pad and sweep over affected areas. Use SPF daily."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  // ============================================================
  // FACE REALITY — CORRECTIVES / ACTIVES
  // ============================================================

  {
    id: "face-reality-5-l-mandelic-serum",
    brand: "Face Reality",
    name: "5% L-Mandelic Serum",
    category: "acne-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 4,
      texture: 4,
      pigment: 4,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 4,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 3,
      sensitive: 3,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["mandelic-acid", "exfoliation"],
    activeLoad: 2,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      providerReview: true
    },

    conflicts: [
      "strong-exfoliation",
      "retinoid",
      "benzoyl-peroxide"
    ],

    reasonTags: [
      "ACNE",
      "CONGESTION",
      "POST_ACNE_MARKS",
      "TEXTURE",
      "PROVIDER_GUIDED"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AS DIRECTED",
      directions: "Shake well. On clean, non-irritated skin, apply 1 pump or the amount directed by your skincare professional."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    {
    id: "face-reality-8-l-mandelic-serum",
    brand: "Face Reality",
    name: "8% L-Mandelic Serum",
    category: "acne-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 5,
      texture: 5,
      pigment: 4,
      redness: 0,
      fineLines: 1,
      laxity: 0,
      dullness: 4,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 2,
      sensitive: 2,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["mandelic-acid", "exfoliation"],
    activeLoad: 3,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      providerReview: true
    },

    conflicts: [
      "strong-exfoliation",
      "retinoid",
      "benzoyl-peroxide"
    ],

    reasonTags: [
      "ACNE",
      "CONGESTION",
      "POST_ACNE_MARKS",
      "TEXTURE",
      "PROVIDER_GUIDED"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AS DIRECTED",
      directions: "Shake well. On clean, non-irritated skin, apply 1 pump or the amount directed by your skincare professional."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-11-l-mandelic-serum",
    brand: "Face Reality",
    name: "11% L-Mandelic Serum",
    category: "advanced-acne-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 5,
      texture: 5,
      pigment: 5,
      redness: 0,
      fineLines: 1,
      laxity: 0,
      dullness: 4,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 3,
      dry: 1,
      sensitive: 1,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["mandelic-acid", "exfoliation"],
    activeLoad: 4,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      providerReview: true
    },

    conflicts: [
      "strong-exfoliation",
      "retinoid",
      "benzoyl-peroxide"
    ],

    reasonTags: [
      "ACNE",
      "CONGESTION",
      "POST_ACNE_MARKS",
      "ADVANCED_ACTIVE",
      "PROVIDER_GUIDED"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AS DIRECTED",
      directions: "Shake well. On clean, non-irritated skin, apply 1 pump or the amount directed by your skincare professional."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-salicylic-plus-serum",
    brand: "Face Reality",
    name: "Salicylic+ Serum",
    category: "acne-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 5,
      pores: 5,
      texture: 4,
      pigment: 1,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 3,
      dehydration: 0,
      congestion: 5,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 3,
      dry: 1,
      sensitive: 1,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["salicylic-acid", "exfoliation"],
    activeLoad: 3,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "defer",
      providerReview: true
    },

    conflicts: [
      "strong-exfoliation",
      "retinoid",
      "benzoyl-peroxide"
    ],

    reasonTags: [
      "ACNE",
      "BLACKHEADS",
      "CONGESTION",
      "OILINESS",
      "PORES",
      "PROVIDER_GUIDED"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AS DIRECTED",
      directions: "Shake well. On clean, non-irritated skin, apply 1 pump or the amount directed by your skincare professional."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-sulfur-spot-treatment",
    brand: "Face Reality",
    name: "Sulfur Spot Treatment",
    category: "spot-treatment",
    routineSlot: "specialty",
    amPm: ["AS_NEEDED"],

    concerns: {
      acne: 5,
      pores: 0,
      texture: 0,
      pigment: 0,
      redness: 0,
      fineLines: 0,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 1,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 4,
      dry: 3,
      sensitive: 3,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["sulfur", "spot-treatment"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-spot-treatment"],

    reasonTags: [
      "BREAKOUT",
      "SPOT_TREATMENT",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "spot-treatment"],

        usage: {
      timing: "AM +/OR PM \u00b7 SPOT TREAT",
      directions: "Apply a small amount directly to inflamed breakouts. Allow 1-2 minutes to dry, then follow with moisturizer and SPF in the morning."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-antioxidant-peptide-face-serum",
    brand: "Face Reality",
    name: "Antioxidant Peptide Face Serum",
    category: "antioxidant-serum",
    routineSlot: "antioxidant",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 1,
      pores: 0,
      texture: 2,
      pigment: 2,
      redness: 2,
      fineLines: 3,
      laxity: 1,
      dullness: 4,
      dehydration: 2,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 4,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["antioxidant", "peptide"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "allow",
      barrierImpaired: "review",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-antioxidant"],

    reasonTags: [
      "ACNE_SAFE",
      "ANTIOXIDANT",
      "DULLNESS",
      "AGING_SUPPORT"
    ],

    specialtyModules: ["acne"],

        usage: {
      timing: "AM + PM",
      directions: "Shake well. Apply 1 pump to clean, non-irritated skin before moisturizer."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "face-reality-glowtone-corrective-serum",
    brand: "Face Reality",
    name: "glowTone Corrective Serum",
    category: "brightening-corrective",
    routineSlot: "corrective",
    amPm: ["AM", "PM"],

    concerns: {
      acne: 2,
      pores: 1,
      texture: 2,
      pigment: 5,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 5,
      dehydration: 0,
      congestion: 1,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 3,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["brightening"],
    activeLoad: 1,

    gates: {
      pregnancy: "review",
      breastfeeding: "review",
      prescriptionRetinoid: "review",
      barrierImpaired: "defer",
      severeSensitivity: "review"
    },

    conflicts: ["duplicate-pigment-corrective"],

    reasonTags: [
      "POST_ACNE_MARKS",
      "PIGMENT",
      "DULLNESS",
      "ACNE_SAFE"
    ],

    specialtyModules: ["acne", "pigment"],

        usage: {
      timing: "AM + PM",
      directions: "After cleansing and toning, apply 1 pump as directed. Follow with moisturizer and SPF in the morning."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
    // ============================================================
  // COLORESCIENCE — SPF ONLY
  // ============================================================

  {
    id: "colorescience-face-shield-flex-spf-50",
    brand: "Colorescience",
    name: "Sunforgettable Total Protection Face Shield Flex SPF 50",
    category: "tinted-spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 3,
      redness: 2,
      fineLines: 2,
      laxity: 0,
      dullness: 1,
      dehydration: 1,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "TINTED",
      "COVERAGE",
      "PIGMENT",
      "REDNESS"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Rub at least a nickel-sized amount between fingertips to activate pigments, then blend evenly over moisturized face. Allow 1-2 minutes for shade to develop; reapply every 2 hours."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "colorescience-face-shield-classic-spf-50",
    brand: "Colorescience",
    name: "Sunforgettable Total Protection Face Shield Classic SPF 50",
    category: "spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 2,
      fineLines: 2,
      laxity: 0,
      dullness: 1,
      dehydration: 1,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "NATURAL_FINISH",
      "SHEER",
      "DAILY_PROTECTION"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Shake well and apply at least a nickel-sized amount evenly to the face; use more for neck and decollete. Reapply every 2 hours."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "colorescience-face-shield-glow-spf-50",
    brand: "Colorescience",
    name: "Sunforgettable Total Protection Face Shield Glow SPF 50",
    category: "glow-spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 1,
      fineLines: 2,
      laxity: 0,
      dullness: 4,
      dehydration: 1,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 3,
      combination: 4,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 3
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "GLOW",
      "RADIANCE",
      "DEWY_FINISH"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Shake well and apply liberally and evenly to face, neck, and decollete. Reapply at least every 2 hours."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "colorescience-face-shield-bronze-spf-50",
    brand: "Colorescience",
    name: "Sunforgettable Total Protection Face Shield Bronze SPF 50",
    category: "bronzing-spf",
    routineSlot: "spf",
    amPm: ["AM"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 3,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 4,
      combination: 5,
      balanced: 5,
      dry: 5,
      sensitive: 5,
      resilient: 5,
      acneProne: 4
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "BRONZE",
      "COSMETIC_FINISH",
      "GLOW"
    ],

    specialtyModules: ["spf"],

        usage: {
      timing: "AM + REAPPLY",
      directions: "Shake well and apply liberally and evenly to face, neck, and decollete. Reapply at least every 2 hours."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },

  {
    id: "colorescience-brush-on-shield-spf-50",
    brand: "Colorescience",
    name: "Sunforgettable Total Protection Brush-On Shield SPF 50",
    category: "spf-reapplication",
    routineSlot: "spf",
    amPm: ["REAPPLY"],

    concerns: {
      acne: 0,
      pores: 0,
      texture: 0,
      pigment: 2,
      redness: 1,
      fineLines: 1,
      laxity: 0,
      dullness: 0,
      dehydration: 0,
      congestion: 0,
      underEye: 0
    },

    fit: {
      oily: 5,
      combination: 5,
      balanced: 5,
      dry: 4,
      sensitive: 5,
      resilient: 5,
      acneProne: 5
    },

    activeClasses: ["spf"],
    activeLoad: 0,

    gates: {
      pregnancy: "allow",
      breastfeeding: "allow",
      prescriptionRetinoid: "allow",
      barrierImpaired: "allow",
      severeSensitivity: "allow"
    },

    conflicts: [],

    reasonTags: [
      "SPF",
      "REAPPLICATION",
      "PORTABILITY",
      "OUTDOOR"
    ],

    specialtyModules: ["spf-reapplication"],

        usage: {
      timing: "REAPPLY SPF",
      directions: "Tap to activate powder flow, then sweep over dry skin or makeup in small circular motions for at least 60 seconds with multiple passes. Reapply every 2 hours."
    },

commerce: {
      route: "shopify",
      productHandle: null,
      productId: null,
      variantId: null
    }
  },
  ];


// ============================================================
// RISE SKIN CONCIERGE — PRODUCT HELPERS
// ============================================================

window.RISE_SKIN = window.RISE_SKIN || {};

window.RISE_SKIN.getProducts = function () {
  return window.RISE_SKIN_PRODUCTS || [];
};

window.RISE_SKIN.getProductById = function (productId) {
  return (window.RISE_SKIN_PRODUCTS || []).find(
    (product) => product.id === productId
  ) || null;
};

window.RISE_SKIN.getProductsByBrand = function (brandName) {
  return (window.RISE_SKIN_PRODUCTS || []).filter(
    (product) => product.brand === brandName
  );
};

window.RISE_SKIN.getProductsBySlot = function (routineSlot) {
  return (window.RISE_SKIN_PRODUCTS || []).filter(
    (product) => product.routineSlot === routineSlot
  );
};

window.RISE_SKIN.getProductsByModule = function (moduleName) {
  return (window.RISE_SKIN_PRODUCTS || []).filter(
    (product) =>
      Array.isArray(product.specialtyModules) &&
      product.specialtyModules.includes(moduleName)
  );
};

window.RISE_SKIN.getCartEligibleProducts = function () {
  return (window.RISE_SKIN_PRODUCTS || []).filter((product) => {
    return (
      product.commerce &&
      product.commerce.route === "shopify" &&
      product.commerce.variantId
    );
  });
};


// ============================================================
// VALIDATION
// ============================================================

window.RISE_SKIN.validateProducts = function () {
  const products = window.RISE_SKIN_PRODUCTS || [];
  const issues = [];
  const warnings = [];
  const ids = new Set();

  products.forEach((product, index) => {
    const label = product.name || `Product at index ${index}`;

    if (!product.id) {
      issues.push(`${label}: missing id`);
    }

    if (product.id && ids.has(product.id)) {
      issues.push(`${label}: duplicate id "${product.id}"`);
    }

    if (product.id) {
      ids.add(product.id);
    }

    if (!product.brand) {
      issues.push(`${label}: missing brand`);
    }

    if (!product.name) {
      issues.push(`Product at index ${index}: missing name`);
    }

    if (!product.category) {
      issues.push(`${label}: missing category`);
    }

    if (!product.routineSlot) {
      issues.push(`${label}: missing routineSlot`);
    }

    if (!Array.isArray(product.amPm)) {
      issues.push(`${label}: amPm must be an array`);
    }

    if (!product.concerns || typeof product.concerns !== "object") {
      issues.push(`${label}: missing concerns object`);
    }

    if (!product.fit || typeof product.fit !== "object") {
      issues.push(`${label}: missing fit object`);
    }

    if (!product.gates || typeof product.gates !== "object") {
      issues.push(`${label}: missing gates object`);
    }

    if (!Array.isArray(product.activeClasses)) {
      issues.push(`${label}: activeClasses must be an array`);
    }

    if (!Array.isArray(product.conflicts)) {
      issues.push(`${label}: conflicts must be an array`);
    }

    if (!Array.isArray(product.reasonTags)) {
      issues.push(`${label}: reasonTags must be an array`);
    }

    if (!product.commerce || typeof product.commerce !== "object") {
      issues.push(`${label}: missing commerce object`);
    } else {
      if (!product.commerce.route) {
        issues.push(`${label}: missing commerce.route`);
      }

      if (
        product.commerce.route === "shopify" &&
        !product.commerce.variantId
      ) {
        warnings.push(
          `${label}: Shopify product is not mapped to a variantId yet`
        );
      }

      if (
        product.commerce.route === "skinbetter" &&
        !product.commerce.productHandle
      ) {
        warnings.push(
          `${label}: SkinBetter commerce route has no productHandle yet`
        );
      }
    }
  });

  const report = {
    productCount: products.length,
    errors: issues,
    warnings: warnings,
    valid: issues.length === 0
  };

  if (window.RISE_DEBUG) {
    console.group("RISE SKIN CONCIERGE — PRODUCT VALIDATION");

    console.log(`Products loaded: ${report.productCount}`);

    if (report.errors.length) {
      console.error("Errors:", report.errors);
    } else {
      console.log("No structural product errors found.");
    }

    if (report.warnings.length) {
      console.warn("Warnings:", report.warnings);
    }

    console.groupEnd();
  }

  return report;
};


// ============================================================
// DEBUG SUMMARY
// ============================================================

window.RISE_SKIN.debugProductSummary = function () {
  const products = window.RISE_SKIN_PRODUCTS || [];
  const byBrand = {};
  const bySlot = {};

  products.forEach((product) => {
    byBrand[product.brand] = (byBrand[product.brand] || 0) + 1;

    bySlot[product.routineSlot] =
      (bySlot[product.routineSlot] || 0) + 1;
  });

  const summary = {
    totalProducts: products.length,
    byBrand,
    bySlot
  };

  if (window.RISE_DEBUG) {
    console.group("RISE SKIN CONCIERGE — PRODUCT SUMMARY");
    console.log("Total products:", products.length);
    console.table(byBrand);
    console.table(bySlot);
    console.groupEnd();
  }

  return summary;
};


// ============================================================
// INITIAL DEBUG CHECK
// ============================================================

if (window.RISE_DEBUG) {
  window.RISE_SKIN.validateProducts();
  window.RISE_SKIN.debugProductSummary();
}